import React from 'react';
import ServiceRow from './ServiceRow';

const Services = () => {
    const services = [
        {
            icon: <i class="fa-solid fa-table"></i>,
            title: "Computer Basics"
        },
        {
            icon: <i class="fa-solid fa-envelopes-bulk"></i>,
            title: "Computer Advanced"
        },
        {
            icon: <i class="fa-solid fa-book-open"></i>,
            title: "Wordpress"
        },
        {
            icon: <i class="fa-brands fa-wordpress"></i>,
            title: "Computer Windows"
        },
        {
            icon: <i class="fa-brands fa-windows"></i>,
            title: "Web Develpment"
        },
        {
            icon: <i class="fa-brands fa-apple"></i>,
            title: "App Development"
        },
        {
            icon: <i class="fa-brands fa-dropbox"></i>,
            title: "Computer Engeneearing"
        },
        {
            icon: <i class="fa-solid fa-briefcase"></i>,
            title: "Job Hunting"
        }
    ]
    return (
        <div id='services' className='py-11 lg:py-20 max-w-6xl mx-auto px-5 xl:px-0'>
            <div class="mt-6 md:flex md:items-center md:justify-between">
                <div>
                    <h1 class="text-3xl font-semibold text-gray-800 capitalize lg:text-4xl dark:text-white">
                        Our Services
                    </h1>
                    <p className='text-gray-500 pt-2'>We are here for your Trasted Partner.</p>
                </div>

                <div class="mt-5 md:mt-0">
                    <h3 className='text-lg  cursor-pointer'>Browse All <i class="fa-solid fa-angle-right"></i></h3>
                </div>
            </div>
            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-7 sm:mt-9 mt-5'>
                {
                    services.map(data => <ServiceRow data={data} 
                    
                    />)
                }
            </div>
        </div>
    );
};

export default Services;